import { render, staticRenderFns } from "./LetterId.vue?vue&type=template&id=4d5c1f44"
import script from "./LetterId.vue?vue&type=script&lang=js"
export * from "./LetterId.vue?vue&type=script&lang=js"
import style0 from "./LetterId.vue?vue&type=style&index=0&id=4d5c1f44&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports